import * as React from 'react';
import styled from '@emotion/styled';

import './holiday-allowance-modal.scss';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import { IWeekPayInfo } from '../payroll-register';
import moment from 'moment';
import { addComma } from 'constants/utils';

interface Props {
  isVisible: boolean;
  onClose: Function;
  data: IWeekPayInfo[];
}

const ModalBackground = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
`;

const HolidayAllowanceModal: React.FunctionComponent<Props> = ({ isVisible, onClose, data }) => {
  const onCloseModal = () => {
    onClose(false);
  };
  let sum = 0;
  if (data.length > 0) {
    data.map((i) => (sum = sum + Number(i.PAY)));
  }

  if (!isVisible) return null;
  return (
    <div className="holiday-allowance-modal">
      <div className="holiday-allowance-modal__content">
        <div className="holiday-allowance-modal__action">
          <div className="holiday-allowance-modal__action__close" onClick={onCloseModal}>
            <Close />
          </div>
        </div>
        <div className="holiday-allowance__header">주휴수당 내역</div>

        <div className="holiday-allowance__body">
          {data.map((i, index) => (
            <div
              className={
                index !== data.length - 1 ? 'holiday-allowance__body__weeks' : 'holiday-allowance__body__weeks-last'
              }>
              <div>
                <div className="holiday-allowance__body__week">{index + 1}주차</div>
                <div className="holiday-allowance__body__date">
                  {moment(i.START).format('YYYY.MM.DD')}~{moment(i.END).format('YYYY.MM.DD')}
                </div>
              </div>
              <div className="holiday-allowance__body__won">{addComma(i.PAY)}원</div>
            </div>
          ))}
          <div className="holiday-allowance__body__footer">
            <div className="holiday-allowance__body__bottom">
              <div className="holiday-allowance__body__bottom__sum">합계</div>
              <div className="holiday-allowance__body__bottom__value">{addComma(sum.toString())}원</div>
            </div>
          </div>
        </div>
      </div>
      <ModalBackground onClick={onCloseModal} />
    </div>
  );
};
export default HolidayAllowanceModal;
